import { flattenUrls, HREF_PHONE_NUMBER, URLS } from "@/lib/consts";
import type { CTA } from "@/lib/types";
import { formatForLabel } from "@/lib/utils";

const NAVIGATION_LIST: CTA[] = flattenUrls(URLS, ([key, value]) => {
  const item: CTA = {
    label: formatForLabel(key),
    href: value,
    variant: "link",
  };

  return item;
});

const MENU_CTAS: CTA[] = [
  {
    label: "START WITH A FLOOR PLAN",
    variant: "secondary",
    href: URLS.OUR_FLOOR_PLANS,
    icon: "layout",
  },
  {
    label: "TALK TO OUR TEAM",
    variant: "default",
    href: HREF_PHONE_NUMBER,
    icon: "phone-call",
  },
];

export { NAVIGATION_LIST, MENU_CTAS };
